import React from "react";
import { Affix, Button } from "antd";
import styled from "styled-components";
import { FormattedMessage } from "react-intl";
import { ArrowLeftOutlined, CloudSyncOutlined } from "@ant-design/icons";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { useParams } from "react-router-dom";

import { history } from "../../../store";

import { selectors as LOADING_SELECTOR } from "../../../ducks/loadingData";

import { LOADING_DATA_TYPE } from "../../../lib/utils/constants";

const BackButton = ({ loadingDataType, detailView }) => {
  const isUpdatingChannel = loadingDataType === LOADING_DATA_TYPE.updateNodeChannel;
  const {
    location: { search },
  } = window;
  const { cwid, cnn } = useParams();

  return (
    <Affix offsetBottom={0}>
      <StyledButton
        loading={isUpdatingChannel}
        icon={<ArrowLeftOutlined />}
        type="primary"
        onClick={() => history.push(`/node/${cwid}/${cnn}/channels${search}`)}
      >
        <span>
          <FormattedMessage id="BackButton.backChannelList" defaultMessage="Back to channel list" />
        </span>
        <StyledSaveInfo>
          (
          {!isUpdatingChannel && (
            <>
              <StyledSaveInfo>
                <FormattedMessage id="BackButton.saved" defaultMessage="Saved" />
              </StyledSaveInfo>
            </>
          )}
          {isUpdatingChannel && (
            <>
              {!detailView && (
                <StyledSaveInfo>
                  {!isUpdatingChannel && (
                    <>
                      <StyledSaveInfo>
                        <FormattedMessage id="BackButton.saved" defaultMessage="Saved" />
                      </StyledSaveInfo>
                    </>
                  )}
                  {isUpdatingChannel && (
                    <>
                      <StyledIcon>
                        <CloudSyncOutlined />
                      </StyledIcon>
                      <StyledSaveInfo>
                        <FormattedMessage id="BackButton.saving" defaultMessage="Saving..." />
                      </StyledSaveInfo>
                    </>
                  )}
                </StyledSaveInfo>
              )}
            </>
          )}
          )
        </StyledSaveInfo>
      </StyledButton>
    </Affix>
  );
};

const StyledIcon = styled.span`
  margin-left: 3px;
`;

const StyledSaveInfo = styled.span`
  margin: 0 3px;
`;

const StyledButton = styled(Button)`
  width: 100%;
`;

BackButton.propTypes = {
  loadingDataType: PropTypes.string.isRequired,
  detailView: PropTypes.bool,
};

BackButton.defaultProps = {
  detailView: null,
};

const mapStateToProps = (state) => ({
  loading: LOADING_SELECTOR.getLoading(state),
  loadingDataType: LOADING_SELECTOR.getLoadingDataType(state),
});

export default connect(mapStateToProps, null)(BackButton);
